<template>
  <div class="ListingFavourite text-[1.9rem]">
    <template v-if="signedIn">
      <button
        data-gtm-trigger="add_to_favorites"
        :data-gtm-title="listing.title"
        v-show="!liked"
        @click.prevent="toggleLike"
        class="flex items-center"
      >
        <FaIcon :icon="['far', 'heart']" class="text-gray-950 hover:text-primary active:text-primary" />
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
      <button
        data-gtm-trigger="remove_from_favorites"
        :data-gtm-title="listing.title"
        v-show="liked"
        class="liked flex items-center"
        @click.prevent="toggleLike"
      >
        <FaIcon :icon="['fas', 'heart']" class="text-bt-blue-500" />
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
    </template>

    <template v-else>
      <button
        data-gtm-trigger="add_to_favorites"
        :data-gtm-title="listing.title"
        @click.prevent="promptSignIn"
        class="text-primary flex items-center"
        aria-label="Add to favourites"
      >
        <FaIcon :icon="['far', 'heart']" class="text-gray-950 hover:text-primary" />
        <slot :liked="false" :count="listing.favourites_count"></slot>
      </button>
    </template>
  </div>
</template>

<script>
import Http from "@/lib/Http"
export default {
  name: "Listing.Favourite",
  props: {
    listing: {
      type: Object,
      required: true,
    },
    guestFavourites: {
      type: [],
      required: false,
      default: [],
    },
  },
  data() {
    return {
      liked: false,
    }
  },
  mounted() {
    this.liked = this.signedIn ? this.listing.liked : false
  },
  methods: {
    promptSignIn() {
      document.dispatchEvent(new CustomEvent("show-session-modal", { detail: { title: "Login to favourite artworks" } }))
    },
    toggleLike() {
      const liked = this.liked
      const { favourites_count } = this.listing

      this.liked = !liked
      if (this.liked) {
        this.listing.favourites_count = favourites_count + 1
      } else {
        this.listing.favourites_count = favourites_count - 1
      }

      Http({
        method: liked ? "DELETE" : "POST",
        url: "/api/listings/favourites",
        params: { listing_id: this.listing.id },
      })
        .then(() => {
          $.getScript("/listings/favourites/navbar")
          this.favouritesCount += liked ? -1 : 1
        })
        .catch((e) => {
          this.liked = liked
        })
    },
  },
  computed: {
    signedIn() {
      return window.config.userSignedIn
    },
  },
}
</script>
